import isDate from 'validator/lib/isDate'

export const rxLpChIsValidDate = (date?: string): boolean => {
  try {
    return isDate(String(date), {
      delimiters: ['.'],
      format: 'DD.MM.YYYY',
      strictMode: true,
    })
  } catch {
    return false
  }
}
